<template>
  <div class="ac-card-content">
    <div class="grid-row jc-c margin-top-24">
      <img
        src="@shared/assets/img/logo/black-logo.png"
        class="ac-logo"
        alt="ac-logo"
      />
    </div>
    <div class="ac-body-container">
      <div
        v-if="!activeTab || activeTab === 'guide'"
        class="guide-container"
      >
        <div class="sac__font-36 bold manRope">
          Installation Guide
        </div>
        <div class="sac__font-20 bold manRope">
          1. Input Your ServiceTitan Tenant ID:
        </div>
        <ul>
          <li>
            Enter your ServiceTitan Tenant ID in the following screen.
            This ID is required to initialize the integration process with SmartAC.com.
          </li>
          <li>
            Once submitted, our dev team will review and manually enable the integration on our end.
          </li>
        </ul>
        <div class="sac__font-20 bold manRope">
          2.  Go to ServiceTitan:
        </div>
        <ul>
          <li>After the Tenant ID is processed,log in to your ServiceTitan account.</li>
          <li>Navigate to the ”API Application Access”, under Integrations section.</li>
          <li>Click “Connect New App” and connect to SmartAC.com.</li>
        </ul>
        <div class="sac__font-20 bold manRope">
          3. Generate Client Credentials:
        </div>
        <ul>
          <li>
            Once installed, create your Client ID and Client Secret ID from within ServiceTitan.
          </li>
        </ul>
        <div class="sac__font-20 bold manRope">
          4. Return to SmartAC.com:
        </div>
        <ul>
          <li>
            Enter SmartAC.com and enter the Client ID and
            Client Secret ID into the integration page.
          </li>
        </ul>
      </div>
      <div
        v-else-if="activeTab === 'input'"
        class="flex-row just-center"
      >
        <div class="flex-column start just-start">
          <div class="sac__font-20 bold manRope">
            ServiceTitan Integration
          </div>
          <div class="sac__font-16 med n70 manRope margin-top-8">
            Please enter your
            <a
              class="sac__font-16 med f-primary underline manRope"
              target="_blank"
              :href="tenantIdLink"
            >ServiceTitan
            </a>
            Tenant ID below to proceed with the integration setup.
          </div>
          <div
            class="sac__font-16 semi-bold manRope margin-top-16"
          >
            ServiceTitan Tenant ID
          </div>
          <SACInput
            class="margin-top-4"
            field="tenantId"
            placeholder="Enter Tenant ID"
            :value="tenantId"
            :change="change"
            :error="errObj.tenantIdErr"
          />
        </div>
      </div>
      <div
        v-else-if="!loading && activeTab === 'confirmation'"
        class="confirmation-container"
      >
        <div class="flex-column just-center align-center">
          <img
            src="@shared/assets/img/general/SetUpComplete.svg"
            class="setup-complete"
            alt="complete"
          />
          <div class="sac__font-20 bold manRope">
            Thank you!
          </div>
          <div class="sac__font-16 med-gray manRope">
            We've received your Tenant ID. We will notify you via email
            when the next steps are ready.
          </div>
        </div>
      </div>
    </div>
    <div class="setup-footer-container">
      <div />
      <div class="grid-column ai-c gap-16">
        <button
          v-if="activeTab !== 'confirmation'"
          class="margin-right-4"
          type="button"
          @click="back"
        >
          <img
            class="img-size-40"
            src="@shared/assets/img/general/arrow-left-circle.svg"
            alt="circle"
          />
        </button>
        <button
          type="button"
          class="next-btn"
          @click="next"
        >
          <span class="sac__font-12 f-white bold">
            {{ nextText }}
          </span>
          <img
            class="img-size-10"
            src="@shared/assets/img/general/arrow-right-white.png"
            alt="right"
          />
        </button>
      </div>
    </div>
    <ProcessOverlay
      :show="loading"
      text="Saving Tenant ID"
      overlayClass="ac-overlay"
    />
  </div>
</template>
<script>
import SACInput from '@shared/components/sac/SACInput.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'ServiceTitanSetUp',
  components: {
    SACInput,
    ProcessOverlay,
  },
  props: {
    toggle: Function,
    update: Function,
  },
  data() {
    return {
      activeTab: '',
      tenantId: '',
      errObj: {},
      tenantIdLink: `${process.env.ST_URL}/#/Settings/Api-Apps`,
      loading: false,
    };
  },
  computed: {
    nextText() {
      if (!this.activeTab || this.activeTab === 'guide') {
        return 'Next';
      }
      if (this.activeTab === 'input') {
        return 'Submit';
      }
      if (this.activeTab === 'confirmation') {
        return 'Done';
      }
      return '';
    },
  },
  methods: {
    change(f, v) {
      this[f] = v;
    },
    async next() {
      if (!this.activeTab || this.activeTab === 'guide') {
        this.activeTab = 'input';
        return;
      }
      if (this.activeTab === 'input') {
        await this.handleTenantId();
        return;
      }
      if (this.activeTab === 'confirmation') {
        this.toggle(false);
      }
    },
    back() {
      if (this.activeTab === 'input') {
        this.activeTab = 'guide';
      } else {
        const changes = [{
          field: 'showIntActionModal',
          value: true,
        }, {
          field: 'actionIntModalView',
          value: 'titan-connect',
        }];

        this.$store.dispatch('changeSettingValues', changes);
      }
    },
    async handleTenantId() {
      const err = {};
      if (!this.tenantId) {
        err.tenantIdErr = 'Please enter your Tenant ID';
        this.errObj = err;
      } else {
        this.loading = true;
        const corpId = this.$store.state.admin.current.corporationId;
        await this.$store.dispatch('saveTenantId', {
          tenantId: this.tenantId,
          corpId,
        });
        this.loading = false;
        this.activeTab = 'confirmation';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.guide-container {
  padding: 0 35px;
  display: grid;
  gap: 16px;
  ul {
    list-style-type: disc;
    margin-left: 40px;
    padding: 0;
  }
  li {
    font-size: 16px;
    margin-bottom: 8px;
  }
}
.confirmation-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.tenant-input-container {
  display: flex;
  align-items:start;
  justify-content: start;
}
.ac-logo {
  width: 184px;
  height: 21px;
}
.setup-footer-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-top: 1px solid $N10;
  padding: 20px;
  justify-content: space-between;
  .next-btn {
    display: flex;
    flex-direction: row;
    width: 117px;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-radius: 24px;
    background-color: #009938;
    .next-btn-icon {
      width: 24px;
      height: 24px;
    }
  }
}
.setup-complete {
  width: 364px;
  height: 310px;
}

</style>
